import { render, staticRenderFns } from "./PromoSection.vue?vue&type=template&id=36fa347c&"
import script from "./PromoSection.vue?vue&type=script&lang=js&"
export * from "./PromoSection.vue?vue&type=script&lang=js&"
import style0 from "./PromoSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports